import { defaultSchema } from "rehype-sanitize";

const styleAndClassName = ["className", "style"];

export const CLEAN_SPACE_BETWEEN_NUMBER_DOT_AND_TEXT_REGEX = /^(\d+\.)\s{2,}/gm;
export const STYLE_BLOCK_REGEX = /<style\b[^>]*>[\s\S]*?<\/style>/gi;

export const markdownSanitizeSchema = {
	...defaultSchema,
	clobber: [],
	// `u` carries the editor's underline mark: markdown has no syntax for one, so it
	// only survives a save as a raw tag, and stripping it here turned every underline
	// back into plain text on reload.
	tagNames: [
		...(defaultSchema.tagNames ?? []),
		"aside",
		"legend",
		"object",
		"colgroup",
		"col",
		"u",
	],
	attributes: {
		...defaultSchema.attributes,
		div: [...(defaultSchema.attributes?.div ?? []), ...styleAndClassName],
		span: styleAndClassName,
		// `dataHtmlTable` is set by `rehypeFlagHtmlTables` to record that a table
		// was authored as raw HTML rather than as a GFM pipe table. Sanitization
		// matches hast property names, hence the camelCase spelling.
		table: [
			...(defaultSchema.attributes?.table ?? []),
			...styleAndClassName,
			"dataHtmlTable",
			"dataTableSections",
		],
		th: [...(defaultSchema.attributes?.th ?? []), ...styleAndClassName],
		td: [...(defaultSchema.attributes?.td ?? []), ...styleAndClassName],
		tr: [...(defaultSchema.attributes?.tr ?? []), ...styleAndClassName],
		tbody: [...(defaultSchema.attributes?.tbody ?? []), ...styleAndClassName],
		thead: [...(defaultSchema.attributes?.thead ?? []), ...styleAndClassName],
		tfoot: [...(defaultSchema.attributes?.tfoot ?? []), ...styleAndClassName],
		caption: [...(defaultSchema.attributes?.caption ?? []), ...styleAndClassName],
		colgroup: [...(defaultSchema.attributes?.colgroup ?? []), ...styleAndClassName],
		col: [...(defaultSchema.attributes?.col ?? []), ...styleAndClassName],
		source: [
			"contentid",
			"vectorid",
			"page",
			"excerpt",
			"index",
			"messageid",
			"imageurl",
			"type",
			"loading",
		],
		aside: ["error", ...styleAndClassName],
		legend: ["text", ...styleAndClassName],
		object: ["id"],
	},
};
